import { Component, OnInit } from '@angular/core';
import { HttpClient,HttpHeaders,HttpRequest } from '@angular/common/http';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';  


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  tData:any;
  key:any="gau98187rav87752";

  constructor(private router: Router,private http:HttpClient) { }

  ngOnInit(): void {
   $('.registerBgImg').css({'width':window.innerWidth+12,'height':window.innerHeight});
  }

  onSubmit(form: NgForm)
  {
    
	//   this.http.post<any>('https://api.datapitcher.com/api/users/',
	//   {
	//   email:form.value.email,
	//   phone:form.value.phone,
	//   password:form.value.password
	//   }
	//   ).subscribe(res=>{ 
	//      this.http.post<any>('https://api.datapitcher.com/api/login/',
	//      {
	//       username:res.email,
	//       password:form.value.password
	//      }
	//      ).subscribe(resp=>{
	//      this.tData=CryptoJS.AES.encrypt(resp.token,this.key).toString();
    //      Cookies.set('tData', this.tData);
	//        this.router.navigate(['/home']);
	//      });
	//   },error=>{
	//   console.log(error.error);
	//   console.log('error working');
	//   });

	// after API working please remove this line of code below this comment
	this.router.navigate(['/home']);
  }
 
}
